"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationConfig = exports.initialProductUpdateConfigValues = exports.columns = exports.INITIAL_VISIBLE_COLUMNS = void 0;
exports.INITIAL_VISIBLE_COLUMNS = ["name", "attribute_key", "update_mode", "actions"];
exports.columns = [
    { name: "Name", uid: "name", sortable: true },
    { name: "Attribute", uid: "attribute_key", sortable: true },
    { name: "Update Mode", uid: "update_mode", sortable: true },
    { name: "Actions", uid: "actions", sortable: false },
];
exports.initialProductUpdateConfigValues = {
    name: "",
    attribute_key: "",
    update_mode: "",
    created_by: "",
};
exports.validationConfig = {
    name: { required: true, maxLength: 50 },
    attribute_key: { required: true },
    update_mode: { required: true, enum: ["AUTO_PUBLISH", "REVIEW"] },
    validation_rules: { required: false, json: true },
};
